import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  Popover,
  Checkbox,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  CircularProgress,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
// components
import Label from '../../components/label';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
// sections
import { UserListHead, UserListToolbar } from '../../sections/@dashboard/user';
// mock
// import USERLIST from '../_mock/user';
import { DeleteInterviews, GetInterviewsHavetoTake } from 'src/components/services/httpServices';
import { useNavigate } from 'react-router-dom';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  // { id: 'id', label: 'Sr', alignRight: false },
  { id: 'candidateId', label: 'Candidate Name', alignRight: false },
  { id: 'interviewType', label: 'Interview Type', alignRight: false },
  { id: 'interviewDate', label: 'Interview Date', alignRight: false },
  { id: 'interviewStart', label: 'Start Time', alignRight: false },
  { id: 'interviewEnd', label: 'End Time', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },

  { id: 'vacancyName', label: 'Vacancy Name', alignRight: false },

  // { id: '' },
];

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user?.interviewType?.toLowerCase().indexOf(query.toLowerCase()) != -1 ||
        _user?.status?.toLowerCase().indexOf(query.toLowerCase()) != -1 ||
        _user?.score?.toLowerCase().indexOf(query.toLowerCase()) != -1 ||
        _user?.remarks?.toLowerCase().indexOf(query.toLowerCase()) != -1
      // _user?.mstVacancy?.vacancyName?.toLowerCase().indexOf(query.toLowerCase()) != -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function InterviewsHavetoTake() {
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [interviews, setInterviews] = useState([]);
  const [message, setMessage] = useState('');
  const [saved, setSaved] = useState(false);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [openMessage, setOpenMessage] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      const response = await GetInterviewsHavetoTake();
      console.log('response:', response);
      let savedIntervies = [];
      if (response !== null) {
        response.forEach((element) => {
          savedIntervies.push(element.interview);
        });
        setInterviews(savedIntervies);
        setLoading(false);
      }
    };
    fetch();
  }, []);
  const rowClicked = async (row) => {
    setSelectedRow(row);
  };
  const deleteCandidateInterviews = async (selectedUsersList) => {
    const payload = {
      ids: selected,
    };

    //  console.log(payload);
    let response = await DeleteInterviews(payload);
    //   console.log('PostResponse:', response);

    if (response.status == 200) {
      const isSelected = (user) => {
        let check = selected.includes(user.id);
        return !check;
      };
      const list = interviews.filter((e) => {
        if (isSelected(e)) {
          return e;
        }
      });
      //    console.log('Users:', list);
      setInterviews(list);
      setSelected([]);
      setMessage(response.data);
      setSaved(true);
      setOpenMessage(true);
      // setTimeout(() => {
      //   navigate('/app/user');
      // }, 2000);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpenMessage(true);
      // setPosting(false);
    }
  };
  const handleClose = () => {
    setOpenMessage(false);
  };
  const handleEdit = () => {
    //  console.log('row:', selectedRow);
    navigate(`/app/EditVacancy/${selectedRow.id}`);
  };
  const handleDetails = () => {
    //  console.log('row:', selectedRow);
    navigate(`/app/VacancyDetails/${selectedRow.id}`);
  };
  const handelCreateVacancy = () => {
    navigate('/app/CreateJob');
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = interviews.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };
  const handleClickInterview = (row) => {
    navigate(`/app/InterviewDetail/${row.id}/${row.mstCandidateId}`);
  };
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - interviews.length) : 0;

  const filteredUsers = applySortFilter(interviews, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> Interviews | Immigration System </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Interviews You have to take
          </Typography>
          {/* <Button variant="contained" onClick={handelCreateVacancy} startIcon={<Iconify icon="eva:plus-fill" />}>
            Add
          </Button> */}
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Card>
            <UserListToolbar
              numSelected={selected.length}
              selectedUsers={selected}
              setSelected={setSelected}
              filterName={filterName}
              onFilterName={handleFilterByName}
              deleteUsers={deleteCandidateInterviews}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={interviews.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                      {
                        /* const { id, name, role, status, company, userEmail } = row; */
                      }
                      const {
                        id,
                        interviewType,
                        interviewDate,
                        interviewStart,
                        interviewEnd,
                        recommendation,
                        status,
                        score,
                        decisionDate,
                        remarks,
                        mstVacancy,
                        mstCandidateId,
                        mstCandidate,
                      } = row;
                      const selectedCompany = selected.indexOf(id) !== -1;

                      return (
                        <TableRow
                          hover
                          key={index + 1}
                          tabIndex={-1}
                          role="checkbox"
                          selected={selectedCompany}
                          onClick={() => rowClicked(row)}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox checked={selectedCompany} onChange={(event) => handleClick(event, id)} />
                          </TableCell>
                          {/* <TableCell component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {index + 1}
                              </Typography>
                            </Stack>
                          </TableCell> */}
                          <TableCell
                            onClick={() => handleClickInterview(row)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {mstCandidate?.firstName + ' ' + mstCandidate?.lastName}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell
                            onClick={() => handleClickInterview(row)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {interviewType}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell
                            onClick={() => handleClickInterview(row)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {interviewDate?.split('T')[0]}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell
                            onClick={() => handleClickInterview(row)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {`${interviewStart?.split(':')[0]}:${interviewStart?.split(':')[1]}`}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell
                            onClick={() => handleClickInterview(row)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {`${interviewEnd?.split(':')[0]}:${interviewEnd?.split(':')[1]}`}
                              </Typography>
                            </Stack>
                          </TableCell>

                          {/* <TableCell
                            onClick={() => handleClickInterview(row)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {decisionDate?.split('T')[0]}
                              </Typography>
                            </Stack>
                          </TableCell> */}
                          <TableCell
                            onClick={() => handleClickInterview(row)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Label
                                color={status == 'Pending' ? 'warning' : status == 'Rejected' ? 'error' : 'success'}
                              >
                                {status == 'Pending'
                                  ? sentenceCase('Pending')
                                  : status == 'Rejected'
                                  ? sentenceCase('Rejected')
                                  : sentenceCase('Done')}
                              </Label>
                            </Stack>
                          </TableCell>
                          {/* <TableCell
                            onClick={() => handleClickInterview(row)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {remarks}
                              </Typography>
                            </Stack>
                          </TableCell> */}
                          <TableCell
                            onClick={() => handleClickInterview(row)}
                            component="th"
                            scope="row"
                            padding="none"
                          >
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {mstVacancy?.vacancyName}
                              </Typography>
                            </Stack>
                          </TableCell>

                          {/* <TableCell align="right">
                            <IconButton size="large" color="inherit" onClick={handleOpenMenu}>
                              <Iconify icon={'eva:more-vertical-fill'} />
                            </IconButton>
                          </TableCell> */}
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[25, 50, 100, 500]}
              component="div"
              count={interviews.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        )}
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleEdit}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Edits
        </MenuItem>
        <MenuItem onClick={handleDetails}>
          <Iconify icon={'clarity:details-line'} sx={{ mr: 2 }} />
          Details
        </MenuItem>
        {/* <MenuItem sx={{ color: 'error.main' }} onClick={}>
          <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
          Delete
        </MenuItem> */}
      </Popover>
    </>
  );
}
